import { useQuery } from '@tanstack/react-query';
import api from '@app/services/api';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import type {
    ApiError,
    AIAgentTypesListParams,
    AIAgentTypesListResponse,
} from '@app/services/api.types';

type QueryOptions = Omit<
    UseQueryOptions<AIAgentTypesListResponse['data'], ApiError>,
    'queryKey' | 'queryFn'
>;

export const fetchAgentTypesList = async (
    params: AIAgentTypesListParams
): Promise<AIAgentTypesListResponse['data']> => {
    const url = apiEndpoints.aiAgentTypes.getList(params);
    const response = await api.get(url);
    return response?.data?.data;
};

const useAgentTypes = (params: AIAgentTypesListParams = {}, options?: QueryOptions) => {
    return useQuery<AIAgentTypesListResponse['data'], ApiError>({
        queryKey: ['ai-agent-types', 'list', params],
        queryFn: () => fetchAgentTypesList(params),
        ...options,
    });
};

export default useAgentTypes;
